const hiddenProductData = document.querySelector('input[data-product-hidden]');
const textMeBtn = document.querySelector('#waitlist-text-me-btn');
const emailMeBtn = document.querySelector('#waitlist-email-me-btn');
const emailInput = document.querySelector('#waitlist-email');
const telephoneInput = document.querySelector('#waitlist-telephone');
const telephoneInputContainer = document.querySelector(
  '.waitlist-telephone-wrapper'
);
const checkbox = document.querySelector('#waitlist-marketing');
const checkboxLabel = document.querySelector('.waitlist-marketing-label');
const smsComplianceMsg = document.querySelector('.waitlist-compliance.sms');
const waitListButton = document.querySelector('#waitlist-submit-btn');
const errorMsg = document.querySelector('.waitlist-error');

// swaps active btn class on waitlist text/email btns
function toggleActiveBtn(targetBtn, activeBtn) {
  if (!targetBtn.classList.contains('active')) {
    targetBtn.classList.add('active');
  }
  activeBtn.classList.remove('active');
}

// validators
function validatePhoneNumber(phone) {
  phone = phone.replace(/\s/g, ''); // remove all spaces
  const internationalRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
  if (internationalRegex.test(phone)) {
    return phone.startsWith('+') ? phone : '+' + phone;
  }
  const usRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  if (usRegex.test(phone)) {
    return '+1' + phone;
  }
  return false;
}

function validateEmail(email) {
  const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (emailRegex.test(email)) {
    return true;
  }
  return false;
}

// hides email input and shows telephone input
function toggleWaitlistTextMeBtn(e) {
  e.preventDefault();
  e.stopPropagation();
  telephoneInput.addEventListener('input', hideErrorMsg);
  emailInput.style.display = 'none';
  emailInput.disabled = true;
  telephoneInput.style.display = 'block';
  telephoneInputContainer.style.display = 'flex';
  telephoneInput.disabled = false;
  telephoneInput.focus();
  hideErrorMsg();
  if (acceptsMarketing) {
    smsComplianceMsg.style.display = 'block';
  }
  if (checkboxLabel.textContent.includes('email')) {
    checkboxLabel.textContent = checkboxLabel.textContent.replace(
      'email',
      'text'
    );
  }
  toggleActiveBtn(textMeBtn, emailMeBtn);
}

// hides telephone input and shows email input
function toggleWaitlistEmailMeBtn(e) {
  e.preventDefault();
  e.stopPropagation();
  telephoneInput.disabled = true;
  telephoneInputContainer.style.display = 'none';
  telephoneInput.style.display = 'none';
  emailInput.style.display = 'block';
  emailInput.disabled = false;
  emailInput.focus();
  smsComplianceMsg.style.display = 'none';
  hideErrorMsg();
  if (checkboxLabel.textContent.includes('text')) {
    checkboxLabel.textContent = checkboxLabel.textContent.replace(
      'text',
      'email'
    );
  }
  toggleActiveBtn(emailMeBtn, textMeBtn);
}

function handleWaitlistSubmit() {
  const marketingContainer = document.querySelector(
    '.marketing-checkbox-container'
  );
  marketingContainer.style.display = 'none';
  waitListButton.disabled = true;
  // handles svg inline button textContent
  let currentHTML = waitListButton.innerHTML;
  let newHTML = currentHTML.replace('JOIN WAITLIST', 'JOINED WAITLIST');
  waitListButton.innerHTML = newHTML;
  waitListButton.title = 'Joined Waitlist';
  // make svg visible
  waitListButton.children[0].style.display = 'block';
}

// error message
function waitlistErrorHandler(inputString) {
  const errorMsg = document.querySelector('.waitlist-error');
  errorMsg.style.display = 'block';
  errorMsg.textContent = `Please enter a valid ${inputString}.`;
}

function hideErrorMsg() {
  errorMsg.style.display = 'none';
}

function addToWaitlist(e) {
  e.preventDefault();
  const variantId = hiddenProductData.getAttribute('data-variant-id');
  const productId = hiddenProductData.getAttribute('data-product-id');
  switch (true) {
    case emailInput && emailInput.value !== '':
      const validatedEmail = validateEmail(emailInput.value);
      if (validatedEmail) {
        // back in stock && if acceptsMarketing is true - join Klaviyo
        BIS.create(emailInput.value, variantId, productId, {
          accepts_marketing: acceptsMarketing
        });
        // segment
        analytics.track('Waitlist Joined', {
          index: 'shopify_products',
          variant_id: variantId,
          product_id: productId,
          notification_type: 'Email'
        });
        // Google
        dataLayer.push({ event: 'Waitlist Joined' });
        handleWaitlistSubmit();
      } else {
        waitlistErrorHandler('email');
      }
      break;
    case telephoneInput && telephoneInput.value !== '':
      const validatedPhone = validatePhoneNumber(telephoneInput.value);
      // console.log({ validatedPhone });
      if (validatedPhone) {
        // back in stock && if acceptsMarketing is true - join Attentive
        BIS.create(null, variantId, productId, {
          phone_number: validatedPhone,
          accepts_marketing: acceptsMarketing
        });
        // segment
        analytics.track('Waitlist Joined', {
          index: 'shopify_products',
          variant_id: variantId,
          product_id: productId,
          notification_type: 'SMS'
        });
        // Google
        dataLayer.push({ event: 'Waitlist Joined' });
        if (acceptsMarketing) {
          (async () => {
            try {
              const response = await fetch(
                'https://union.barstoolsports.com/v2/attentive/subscribe',
                {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    user: {
                      phone: validatedPhone
                    },
                    signUpSourceId: '375434'
                  })
                }
              );
              const data = await response.json();
              // console.log(data);
            } catch (error) {
              console.error(error);
            }
          })();
        }
        handleWaitlistSubmit();
      } else {
        waitlistErrorHandler('phone number');
      }
      break;
    default:
      if (textMeBtn.classList.contains('active')) {
        waitlistErrorHandler('phone number');
      } else {
        waitlistErrorHandler('email');
      }
      return;
  }
}

// listeners
textMeBtn.addEventListener('click', toggleWaitlistTextMeBtn);
emailMeBtn.addEventListener('click', toggleWaitlistEmailMeBtn);
waitListButton.addEventListener('click', addToWaitlist);
emailInput.addEventListener('keydown', e => {
  if (e.key === 'Enter') {
    waitListButton.click();
  }
});
telephoneInput.addEventListener('keydown', e => {
  if (e.key === 'Enter') {
    waitListButton.click();
  }
});

telephoneInput.addEventListener('change', () => {
  errorMsg.style.display = 'none';
});

emailInput.addEventListener('change', () => {
  errorMsg.style.display = 'none';
});

telephoneInput.addEventListener('input', hideErrorMsg);
emailInput.addEventListener('input', hideErrorMsg);

let acceptsMarketing;

checkbox.addEventListener('change', () => {
  acceptsMarketing = checkbox.checked;
  if (acceptsMarketing && textMeBtn.classList.contains('active')) {
    smsComplianceMsg.style.display = 'block';
  } else {
    smsComplianceMsg.style.display = 'none';
  }
  // console.log({ acceptsMarketing });
});
